import { CheckboxCard } from "@/src/components/cards";
import SearchKeyHighliter from "@/src/components/seachkeyHighlighter";
import { Income, incomeStatuses } from "@/src/data/allTypes";
import { getName, getUserShortName, uid } from "@/src/utils/utils";
import moment from "moment";
import { openPaymentForm } from "./paymentForm";

export function IncomeCard({
  income,
  searchKey,
  onChange,
}: {
  income: Income;
  searchKey: string;
  onChange: (income: Income) => void;
}) {
  let status = incomeStatuses[income.status];
  return (
    <CheckboxCard
      key={uid()}
      color="blue"
      title={
        <div className="bold capitalize">
          <SearchKeyHighliter searchKey={searchKey}>
            {getName(income.patient)}
          </SearchKeyHighliter>
        </div>
      }
      className={income.status == "pending" ? "empty" : ""}
      subTitle={<div className="gray">{status?.name}</div>}
      status={income.status === "pending" ? "inactive" : "active"}
      onClick={async () => {
        await openPaymentForm({
          income,
          onChange: (newValue) => {
            onChange(newValue);
          },
        });
      }}
      trailing={
        <div className="bold f20 tright main-color">{income.total} DZD</div>
      }
    >
      <div className="c1 gap5 mtop5">
        {income.status == "paid" && (
          <div className="capitalize bold">
            <span >Encaissé par</span>{" "}
            {getUserShortName(income.creator)}
          </div>
        )}
        {income.status == "canceled" && (
          <div className="capitalize">
            <span className="gray">Annulé par</span>{" "}
            {getUserShortName(income.creator)}
          </div>
        )}
        <div>
          {income.appointmentTypes?.map((type, index) => (
            <span key={uid()} className="mright5">
              {index > 0 ? ", " : ""}
              {type?.name}
            </span>
          ))}
        </div>
        <div className="gray">{moment(income._date).format("LL à HH:mm")}</div>
      </div>
    </CheckboxCard>
  );
}
